import React, { Component } from 'react'
import withAds from '../HOCs/withAds'
import Link from './../Carousel/components/Link'
import TitleHeader from './Header'
import Thumb from './Thumb'
import Subject from './Subject'
import { clickTracking } from '../utils/tracking'
import Price from './Price'


class Recommendation extends Component {

  handleClick(ad, adPosition, gallery_id) {
    clickTracking(
      this.props.object_name || "missing",
      "recommendation",
      {
        custom_tag: this.props.custom_tag || "missing",
        list_id: ad.list_id,
        ad_position: adPosition,
        gallery_id: gallery_id
      }
    );
  }

  renderAd(ad, idx, gallery_id) {
    return (
      <Link
        key={idx}
        href={ad.ad_url}
        onClick={() => this.handleClick(ad, idx, gallery_id)}
      >
        <div className="row">
          <div className="row-container">
            <Thumb imageUrl={ad.image_url} alt={ad.subject} listId={ad.list_id} />
            <div className="text-container">
              <Subject subject={ad.subject} />
              <Price value={ad.price} />
            </div>
          </div>
        </div>
      </Link>
    )
  }

  render() {

    const { galleryResponse } = this.props

    if (!galleryResponse.content.length) return null

    return (
        <div className="gallery">
          <TitleHeader title={galleryResponse.title} />
          <div className="items-list">
            {galleryResponse.content.map((item, idx) => (
              this.renderAd(item, idx, galleryResponse.gallery_id)
            ))}
          </div>
        </div>
    )
  }
}

export default (Recommendation)



// WEBPACK FOOTER //
// ./src/node_modules/components/Pimper/MobileCarousel/index.js